import findColorShadeInPalette from '../../../../common/utils/find-color-shade-in-palette';
import reduceColorPointByStep from '../../../../common/utils/reduce-color-point-by-step';
import checkShade from '../../../../common/utils/check-shade';

const dark = (params) => {
  const { backgroundColor, backgroundColorPalette } = params;
  const fallback = {
    rule: 'dropdown.listRowBackground.hover.dark',
    params,
  };
  const targetShade = findColorShadeInPalette(backgroundColor, backgroundColorPalette);

  if (checkShade(targetShade, (shade) => shade >= 200)) {
    return reduceColorPointByStep({
      targetColor: backgroundColor,
      targetColorPalette: backgroundColorPalette,
      step: 2,
      fallback,
    });
  }
  return backgroundColorPalette[50];
};

export default dark;
